import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import { createGeoInput, DefaultGeoInput } from 'react-geoinput';
import { useTranslation } from 'react-i18next';
import { customStylesModal } from '../shared/selectStyle';
import './style.css';

const AddressInput = createGeoInput(DefaultGeoInput);

const ModalEdit = (props) => {
  const { t, i18n } = useTranslation();
  const [addresPlaceholder, setAddresPlaceholder] = useState(false);
  const [modalIsOpen] = useState(props.show);
  const [error, setError] = useState(false);
  const [fileData, setFileData] = useState({
    desc: props.fileData.description,
    _id: props.fileData._id
  });
  const [address, setAddress] = useState(props.fileData.address);
  const [geoDestination, setGeoDestination] = useState('');


  useEffect(() => {
    if (i18n.language === "en") {
      setAddresPlaceholder('Address')
    } else {
      setAddresPlaceholder('Adresa')
    }
  }, []);

  const onAddressChange = value => {
    setError(false);
    setAddress(value)
  }
  const onGeoDestinationChange = value => {
    setError(false);
    setGeoDestination(value)
  }

  const handleChange = e => {
    setError(false);
    setFileData({
      ...fileData,
      [e.target.name]: e.target.value
    });
  }

  const handleSubmit = (event) => {
    const data = { ...fileData, address }
    event.preventDefault();
    if (validateForm()) {
      props.updateLocation(data)
    } else {
      setError(true);
    }
  }

  const validateForm = () => {
    return fileData.desc && address;
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={props.closeModal}
      style={customStylesModal}
      contentLabel="Custom modal"
      ariaHideApp={false}
    >
    
      <div className="modal-header">
        <div className="modal-close"><i className="fa fa-times-circle" aria-hidden="true" onClick={props.closeModal}></i></div>
        <h5>{t('modal.edit.title')}</h5>
      </div>
      <div className="modal-body">
        <form>
          <div className="form-group custom-input">
            <input id='desc' className="form-control" type="text" name="desc" value={fileData.desc} onChange={handleChange} placeholder={t('placeholder.description')} />
          </div>
          <div className="form-group custom-input geo-hint-wrapper">
            <img  src="/assets/images/locationSmall.svg" alt="location" />
            <AddressInput
              addressInput={{
                onChange: onAddressChange,
                value: address,
                placeholder: addresPlaceholder
              }}
              geoDestinationInput={{
                onChange: onGeoDestinationChange,
                value: geoDestination,
              }}
              className="geo-hint-input"
            />
          </div>
          {error ? <div className="message-alert mb-3"><p>{t('requiredFields.msg')} </p></div> : null}
          <div className="modal-footer">
            <button type="submit" className="btn btn-blue" onClick={handleSubmit}>{t('update')}</button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default ModalEdit;


// WEBPACK FOOTER //
// ./src/components/foldersComponent/modalEdit.js